export const CHANGE_FILTER = 'CHANGE_FILTER';



// WEBPACK FOOTER //
// ./src/modules/todoMain/actions/filter/filterActionTypes.js